<template>
  <div class="addPaper">
    <div class="addPaper_head"  v-if="resourcesFrom == '1'">
<!--      <span v-if="showUpload">-->
<!--        <span class="zl_button zl_blueButton" @click="addQues" >添加试卷</span>-->
<!--        &lt;!&ndash; <span class="zl_button zl_blueButton" >上传文件</span> &ndash;&gt;-->
<!--      </span>-->
      <span>
        <el-select
          v-model="categoryId"
          placeholder="全部分类"
          size="mini"
          style="width: 147px"
          clearable
          @clear="initPageTotal"
          @change="postGetPaperByCourseId"
        >
          <el-option
            v-for="item in resourceDatas"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          @keyup.enter.native="postGetPaperByCourseId"
          style="width: 190px"
          v-model="name"
          size="mini"
          placeholder="请输入试卷名称"
          suffix-icon="el-icon-search"
          @clear="initPageTotal"
        ></el-input>
<!--        <el-button type="primary" @click="postGetPaperByCourseId" plain size="mini">查询</el-button>-->
      </span>
    </div>
    <div style="flex: 1;position: relative">
      <el-table
        :data="questionList"
        style="position: absolute"
        @row-click="rowClick"
        :height="`calc(100% - 80px)`"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
      >
        <el-table-column label width="35">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="currentValue">&nbsp;</el-radio>
          </template>
        </el-table-column>

        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width || 'auto'"
          :fixed="item.fixed ? item.fixed : false"
          :show-overflow-tooltip="item.showOverflow ? item.showOverflow : false"
          :align="item.align ? item.align : 'center'"
        >
          <template slot-scope="scope">
            <div
              v-if=" item.prop != 'operation'
                && item.prop != 'difficulty'
                && item.prop != 'totalTime'"
              :title="scope.row[item.prop]"
              v-text="scope.row[item.prop]"
            ></div>
            <!-- 试题难度 -->
            <div
              v-if=" item.prop == 'difficulty' "
            >{{ scope.row.difficulty == 1 ? '简单' : scope.row.difficulty == 2 ? '中等' : scope.row.difficulty == 3 ? '困难' : '' }}</div>
            <!-- 考试时长 -->
            <div
              v-if=" item.prop == 'totalTime' "
            >{{ scope.row.totalTime ? scope.row.totalTime : "--" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              style="color: #1890FF;"
              @click.native.prevent="previewBtn(scope.row,scope.$index)"
            >
              预览
            </el-button>
<!--            <el-button-->
<!--              size="mini"-->
<!--              type="text"-->
<!--              style="color: #1890FF;"-->
<!--              @click.native.prevent="deleteBtn(scope.row,scope.$index)"-->
<!--            >-->
<!--              删除-->
<!--            </el-button>-->
          </template>
        </el-table-column>

        <div slot="empty" class="empty_material">
          <p>暂无试卷</p>
        </div>
      </el-table>
      <Pagination
        style="position: absolute;bottom: 0;right: 0"
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
      ></Pagination>
    </div>

    <!-- 弹窗 -->
    <n-dialog
      :title="'提示'"
      :dialogVisible="addTestPaperShow"
      :width="'400px'"
      :dialogType="dialogType"
      :deleteNum="'1'"
      :deleteName="deleteName"
      :isDedicated="isDedicated"
      @conformFunc="conformFunc"
      @closeDialog="closeDialog"
    ></n-dialog>

  </div>
</template>

<script>
import * as api from "../../api/courseApi";
import * as sourceApi from "../../api/sourceApi";
import * as individualApi from '../../api/individualApi'
import Pagination from "@/components/paginator/paginator";
export default {
  name: "addQuestion.vue",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    },
    courseId: {
      type: [String, Number],
      default: 0,
    },
    resourcesFrom: {
      type: String,
      default: '',
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    addType: {
      type: [String, Number],
      default: -1,
    },
    type: {
      type: [String, Number],
      default: -1,
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      currentValue: this.value,
      questionList: [],
      tableHeader: [
        {
          prop: "paperName",
          label: "试卷名称",
          showOverflow: true,
          align: "left",
        },
        { prop: "totalScore", label: "试卷总分", width: 90 },
        { prop: "questionCount", label: "试题数量", width: 90 },
        // { prop: "totalTime", label: "推荐考试时长", width: 120 },
      ],
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      name: "",
      resourceDatas: [],
      categoryId: "",
      // 删除弹窗
      dialogTitle: "",
      dialogType: "",
      deleteName: "",
      deleteDialog: {
        categoryResourceId: "",
        resourceId: "",
      },
      addTestPaperShow: false,
      isDedicated: true,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit("input", val);
    },
    resourcesFrom() {
      this.init();
    },
  },
  computed: {},
  created() {
    this.findResCategoryByCourseId();
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      if (this.resourcesFrom == '1'){
        this.postGetPaperByCourseId();
      }else{
        this.getTestPaper();
      }
    },
    //添加试题
    // addQues(){
    //   let type = -1;
    //   if (this.type > -1) {
    //     type = this.type == 7 ? 7 : 4;
    //   } else if (this.addType > -1) {
    //     type = this.addType;
    //   }
    //   this.$emit('addQues',type)
    // },
    postGetPaperByCourseId() {
      let params = {
        courseId: this.courseId, //课程id
        categoryId: this.categoryId, //资源分类id
        name: this.name,  // 试卷名称
        pageNum: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
      };
      api.postGetPaperByCourseId(params).then((res) => {
        if (res.code == 0) {
          this.questionList = res.data.list;
          this.pageTotal.total = res.data.total;
        }
      });
    },
    // 获取试卷
    getTestPaper(){
      let obj = {
        subjectId: this.subjectId,
        pageNo: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        paperType: '2',
        status: 1
      };
      individualApi.getPaperList(obj).then(res=>{
        if(res.code == 0){
          this.questionList = res.data.testPaperList;
          this.pageTotal.total = res.data.totalCount;
        }
      })
    },
    // 查询资源分类
    findResCategoryByCourseId() {
      sourceApi
        .FindResCategoryByCourseId(this.courseId)
        .then((res) => {
          if (res.code == "0") {
            this.resourceDatas = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val || this.pageTotal.currentPage;
      this.init();
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.init();
    },
    rowClick(row) {
      this.currentValue = row.id;
      this.$emit('hhdTeacher', row);
    },
    initPageTotal() {
      this.$set(this.pageTotal, "currentPage", 1);
    },

    previewBtn(row) {
      const { href } = this.$router.resolve({
        path: '/switch/test/preview',
        query: {
          paperId: row.id,
          id: this.courseId
        }
      });
      window.open(href, '_blank');
    },
    deleteBtn(row) {
      this.deleteName = row.paperName;
      this.deleteDialog.categoryResourceId = row.categoryResourceId;
      this.deleteDialog.resourceId = row.id;
      this.dialogWidth = "400px";
      this.dialogType = "deleteTestPaper";
      this.addTestPaperShow = true;
    },
    closeDialog() {
      this.addTestPaperShow = false;
      // this.findPageResource();
    },
    conformFunc() {
      let params = {
        courseId: this.courseId, //课程id
        resourceId: this.deleteDialog.resourceId, // id
        categoryResourceId: this.deleteDialog.categoryResourceId
      };
      api.deleteFromCatalog(params).then(res => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          if (this.currentValue == this.deleteDialog.resourceId) this.currentValue = '';   // 删除内容时，清空选中项
          this.closeDialog();
          this.init();
        } else {
          this.$message.error(res.msg);
        }
      })
    }

  },
};
</script>

<style scoped lang="scss">
.addPaper {
  height: 100%;
  width: 100%;
  color: #2b2a33;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .addPaper_head {
    padding: 15px 0;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/component/addPaper.vue